import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { userRoleSignal, userPermissionsSignal, userIdSignal, userSignal } from '../../state/auth.state';
import { AppUser } from '../entities/AppUser';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserContextResponseDTO } from '../DTOs/ClienteUsuarioDTO';
import {
  clienteContextoCargadoSignal,
  esUsuarioInternoSignal,
  setClientesDisponibles
} from './client-context.state';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {

  private http = inject(HttpClient);
  private baseUrl = environment.apiURL;

  /**
   * Carga el contexto completo del usuario tras autenticar con Firebase.
   *
   * Un solo viaje resuelve las tres dimensiones:
   *   - identidad  → iIdUsuario, lEsInterno
   *   - permisos   → rol, permisos
   *   - acceso     → clientes permitidos (Usuarios_Clientes)
   */
  async loadUserRole(firebaseUid: string, correoFirebase = '') {
    const url = `${this.baseUrl}/action/getUserRole`;

    try {
      const resp = await firstValueFrom(
        this.http.post<UserContextResponseDTO>(url, { firebaseUid })
      );

      // Perfil. Antes venía del nodo users/{uid} de Realtime Database, que es
      // de otro sistema y duplicaba lo que la tabla Usuarios ya tiene.
      const perfil: AppUser = {
        uid: firebaseUid,
        email: resp.correo ?? correoFirebase,
        firstName: resp.cNombre ?? '',
        lastName: resp.cApellido ?? '',
      };

      userSignal.set(perfil);

      userIdSignal.set(resp.iIdUsuario ?? null);
      userRoleSignal.set(resp.rol ?? null);
      userPermissionsSignal.set(resp.permisos ?? []);

      // lEsInterno solo identifica pertenencia a SME: no otorga acceso a clientes.
      esUsuarioInternoSignal.set(resp.lEsInterno === 1);

      setClientesDisponibles(
        resp.clientes ?? [],
        firebaseUid,
        resp.iIdClientePreferido ?? null
      );

    } catch (e) {
      userSignal.set(null);
      console.error('[UserRoleService] Error cargando contexto de usuario:', e);
      // NO limpiar rol aquí, solo reportar error.
      // Se marca el contexto como resuelto para que los guards no queden colgados;
      // sin clientes, el guard mandará a la pantalla de "sin acceso".
      clienteContextoCargadoSignal.set(true);
      throw e;
    }
  }
}
